import { render, staticRenderFns } from "./QuadroFrame.vue?vue&type=template&id=20ade1c2&scoped=true&"
import script from "./QuadroFrame.vue?vue&type=script&lang=js&"
export * from "./QuadroFrame.vue?vue&type=script&lang=js&"
import style0 from "./QuadroFrame.vue?vue&type=style&index=0&id=20ade1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ade1c2",
  null
  
)

export default component.exports